/**
 * Mapping between backend roll_type strings and frontend RollVariant numbers.
 * The backend engine picks rolls from its weighted catalog and reports the
 * type as a string. The frontend needs a numeric variant to index into its
 * sprite arrays (regularRolls / hotRolls).
 */
import type { RollVariant } from '@/types'

const SERVER_TO_VARIANT: Record<string, RollVariant> = {
  red: 1,
  green: 2,
  red_green: 3,
  yellow: 4,
  green_yellow: 5,
  hot_large: 6,
  hot_small: 7,
}

export function rollTypeToVariant(serverRollType: string): RollVariant {
  return SERVER_TO_VARIANT[serverRollType] ?? 1
}

export function isHotRollType(serverRollType: string): boolean {
  return serverRollType.startsWith('hot_')
}
